import React from "react";
import { ContainerTableHome, TableViewHome } from "../../../components/Table";
import { formatCurrency, roundNumber } from "../../../services/app";
import { useApp } from "../../../contexts";
import {
  ContainerTableMobileHome,
  LabelTable,
  LabelTableViewAll,
  TextCellTable,
} from "../styles";
import { CellRowImage } from "../../wallet-list/styles";
import { useNavigate } from "react-router-dom";
import { TYPE_WALLET_DETAIL } from "../../../constants";
import {
  DesktopContainer,
  MobileContainer,
} from "../../../components/Container";
import { WalletRowItem } from "./WalletRowItem";
import { ArrowRightIcon } from "../../../components/Icons/ArrowRightIcon";
import { EmptyTable2 } from "../../../components/EmptyTable";
import { getCoinCodeImage } from "../../../utils/helper";
import NumberFormat from "react-number-format";
import {
  baseCurrencyCode,
  decimalScaleByCurrency,
  decimalSeparatorByCurrency,
  prefixCcySymbol,
  suffixCcySymbol,
  thousandSeparatorByCurrency,
} from "../../../utils/Currency";

export const TableCrypto = ({ data }) => {
  const { T, formatLocalCurrency, getCurrency } = useApp();
  const navigate = useNavigate();
  const columns = [
    {
      title: T("Coin"),
      dataIndex: "coin",
      key: "coin",
      width: 350,
      sorter: (a, b) => a.coin.toString().localeCompare(b.coin),
      render: (text, record, index) => {
        return (
          <CellRowImage style={{ minWidth: 60 }}>
            <img
              alt=""
              style={{ width: 28, height: 28 }}
              src={`/assets/images/otc/crypto/${getCoinCodeImage(
                text
              )?.toLowerCase()}.svg`}
            />
            <span style={{ marginLeft: 4 }}>{text}</span>
          </CellRowImage>
        );
      },
    },
    {
      title: T("Market Price"),
      dataIndex: "marketPrice",
      key: "btcValue",
      align: "right",
      className: "btc-value",
      width: 180,
      sorter: (a, b) => a.marketPrice - b.marketPrice,
      render: (text, record, index) => (
        <TextCellTable>
          <NumberFormat
            value={record.marketPrice}
            displayType={"text"}
            thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
            decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
            prefix={prefixCcySymbol(true, getCurrency())}
            suffix={suffixCcySymbol(true, getCurrency())}
            decimalScale={decimalScaleByCurrency(
              baseCurrencyCode(true, getCurrency())
            )}
          ></NumberFormat>
        </TextCellTable>
      ),
    },
    {
      title: T("Amount"),
      dataIndex: "amount",
      key: "amount",
      align: "right",
      width: 400,
      render: (text, record, index) => (
        <TextCellTable>
          <NumberFormat
            value={record.amount}
            displayType={"text"}
            thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
            decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
            decimalScale={8}
          ></NumberFormat>
        </TextCellTable>
      ),
    },
    {
      title: T("Total Value"),
      dataIndex: "totalValue",
      key: "totalValue",
      className: "Total Value",
      align: "right",
      width: 300,
      render: (text, record, index) => (
        <TextCellTable>
          <NumberFormat
            value={record.local}
            displayType={"text"}
            thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
            decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
            prefix={prefixCcySymbol(true, getCurrency())}
            suffix={suffixCcySymbol(true, getCurrency())}
            decimalScale={decimalScaleByCurrency(
              baseCurrencyCode(true, getCurrency())
            )}
          ></NumberFormat>
        </TextCellTable>
      ),
    },
  ];

  const onClickViewAll = () => {
    navigate(`/wallet?type=${TYPE_WALLET_DETAIL.CRYPTO}`);
  };

  const onDetail = (id, item) => {
    if (!id) return;
    navigate(
      `/wallet-detail/${TYPE_WALLET_DETAIL.CRYPTO}?walletId=${id}&code=${item.coin}`
    );
  };
  return (
    <div className="wallet-block">
      <div
        className="flex justify-between items-center
      px-[15px] py-[15px] lg:px-[40px] lg:py-[22px] xl:px-[40px] xls:px-[50px] xls:py-[27px] xls:h-[81px]
      "
      >
        <LabelTable>{T("Crypto")}</LabelTable>
        <LabelTableViewAll
          className=" flex items-center gap-1 cursor-pointer"
          onClick={onClickViewAll}
        >
          {T("View all")}
          <ArrowRightIcon color="#818181" />
        </LabelTableViewAll>
      </div>
      <div className="wallet-block-items">
        <DesktopContainer>
          {!!data?.length && (
            <ContainerTableHome>
              <TableViewHome
                locale={{
                  emptyText: (
                    <EmptyTable2 text={"You have no wallets yet."} T={T} />
                  ),
                }}
                scroll={{ x: true }}
                tableLayout={"fixed"}
                pagination={false}
                dataSource={data}
                columns={columns}
                isClickRow
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      onDetail(record.id, record);
                    },
                  };
                }}
              />
            </ContainerTableHome>
          )}
        </DesktopContainer>
        <MobileContainer>
          {!!data?.length && (
            <ContainerTableMobileHome>
              {data?.map((item, index) => (
                <WalletRowItem
                  onClick={() => onDetail(item.id, item)}
                  key={item.id}
                  coin={item.coin}
                  marketPrice={formatLocalCurrency(item.marketPrice)}
                  amount={
                    <NumberFormat
                      value={item.amount}
                      displayType={"text"}
                      thousandSeparator={thousandSeparatorByCurrency(
                        getCurrency()
                      )}
                      decimalSeparator={decimalSeparatorByCurrency(
                        getCurrency()
                      )}
                      decimalScale={8}
                    ></NumberFormat>
                  }
                  local={formatLocalCurrency(item.local)}
                />
              ))}
            </ContainerTableMobileHome>
          )}
        </MobileContainer>
      </div>
    </div>
  );
};
